import React, { Component } from 'react';
import { Select, Tooltip } from 'antd';
import $ from '../../common/AjaxRequest';

const { Option } = Select;

class SearchRetrieve extends Component {
    componentDidMount() {
        const { value, shouldSearch } = this.props;
        if (shouldSearch) {
            this.queryData(value);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { value, shouldSearch } = nextProps;
        if (!this.props.shouldSearch && shouldSearch) {
            this.queryData(value);
        }
    }

    handleFocus = () => {
        // const { value, data } = this.props;
        // if (!value.key && !data.length) {
        //     this.queryData();
        // }
        this.queryData();
    }

    handleChange = (value) => {
        const { data } = this.props;
        const option = data.find(i => i.value == value) || {};
        const { text } = option;
        this.queryData({key: value, label: text});
    }

    handleSelect = (label, option) => {
        const { props: { value, text } } = option;
        this.queryData({key: value, label: text});
    }

    handleSearch = (label) => {
        this.queryData({key: '', label});
    }

    queryData = (value = {}) => {
        const { url, type, data, params, keyword, config, onChange } = this.props;
        const { id, name, code, type: configType, show } = config;

        let label = value.label;
        if (label) {
            if (show === 'user') {
                const index = label.indexOf('[');
                if (index && label.endsWith(']')) {
                    label = label.slice(0, index);
                }
            } else if (show === 'site') {
                const index = label.indexOf('-(');
                if (index && label.endsWith(')')) {
                    label = label.slice(0, index);
                }
            }
        }

        onChange(type, value, data, true);
        const options = {
            method: 'POST',
            url,
            data: {
                ...params,
                [keyword]: label,
            },
            dataType: 'json',
            doneResult: res => {
                let data;
                if ((res.data || res.datas || res.doctors)) {
                    let sourceData;
                    if (configType === 'site') {
                        sourceData = res.data.siteList.datas;
                    } else if (configType == 'hospital') {
                        sourceData = res.data.hospitalList.datas;
                    } else if (configType == 'researcher') {
                        sourceData = res.doctors;
                    } else {
                        sourceData = res.data ? res.data: res.datas;
                    }
                    data = (sourceData || []).map(item => {
                        const param = {
                            ...item,
                            value: item[id],
                            text: item[name],
                        };
                        if (show === 'user') {
                            param.text = `${item[name]}[${item[code]}]`;
                        } else if (show === 'site') {
                            param.text = `${item[name]}-(${item[code]})`;
                        }
                        return param;
                    });
                } else {
                    data = [];
                }

                const { type, value, onChange } = this.props;
                onChange(type, value, data, false);
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { data, value, style, disabled, placeholder } = this.props;
        const { key, label } = value;
        const dataSource = (data || []).map(i =>
            <Option key={i.value} text={i.text} value={i.value}>
                <Tooltip placement="right" title={i.text}>
                    <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{i.text}</span>
                </Tooltip>
            </Option>
        );
        return (
            <Select
                showSearch
                style={style}
                disabled={disabled}
                onFocus={this.handleFocus}
                onSearch={this.handleSearch}
                onSelect={this.handleSelect}
                onChange={this.handleChange}
                placeholder={placeholder}
                optionLabelProp="children"
                filterOption={false}
                allowClear={true}
                value={label}
            >
                {dataSource}
            </Select>
        );
    }
}

export default SearchRetrieve;


// WEBPACK FOOTER //
// ./src/components/common/SearchRetrieve.js